import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import {
  getMailContentKeyList,
  getMailContent,
  getMailBoxListForContent,
  postSaveMailContent,
  postDeleteMailContent,
} from "@/requests/mailBox";
import { MailContentKey } from "@/models/api/administration/mailBox/mailContentKey";
import { MailContentModel } from "@/models/api/administration/mailBox/mailContentModel";
import { MailContent } from "@/models/api/administration/mailBox/mailContent";
import { MailBox } from "@/models/api/mail/NotificationData";

export interface AdministrationMailBoxContentStateInterface {
  isMailBoxTableLoading: boolean;
  mailBoxTableData: Array<MailBox>;
  selectedMailBoxId: number | null;
  isMailContentTableLoading: boolean;
  mailContentTableData: Array<MailContentKey>;
  selectedMailContentKey: number | null;
  mailContent: MailContentModel;
}

export const AdministrationMailBoxContentState: AdministrationMailBoxContentStateInterface = {
  isMailBoxTableLoading: false,
  mailBoxTableData: new Array<MailBox>(),
  selectedMailBoxId: null,
  isMailContentTableLoading: false,
  mailContentTableData: new Array<MailContentKey>(),
  selectedMailContentKey: null,
  mailContent: new MailContentModel(),
};

const AdministrationMailBoxContentModule = defineModule({
  state: AdministrationMailBoxContentState as AdministrationMailBoxContentStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setIsMailBoxTableLoading(state, param: boolean) {
      state.isMailBoxTableLoading = param;
    },
    setMailBoxTableData(state, param: Array<MailBox>) {
      state.mailBoxTableData = param;
    },
    setSelectedMailBoxId(state, param: number | null) {
      state.selectedMailBoxId = param;
    },
    setIsMailContentTableLoading(state, param: boolean) {
      state.isMailContentTableLoading = param;
    },
    setMailContentTableData(state, param: Array<MailContentKey>) {
      state.mailContentTableData = param;
    },
    setSelectedMailContentKey(state, param: number | null) {
      state.selectedMailContentKey = param;
    },
    setMailContent(state, param: MailContentModel) {
      state.mailContent = param;
    },
  },
  actions: {
    async downloadMailBoxList(context) {
      const { commit } = _moduleActionContext(context);
      commit.setIsMailBoxTableLoading(true);
      const response = await getMailBoxListForContent();
      commit.setMailBoxTableData(response);
      if (response.length > 0) {
        commit.setSelectedMailBoxId(response[0].id);
      } else {
        commit.setSelectedMailBoxId(null);
      }
      commit.setIsMailBoxTableLoading(false);
    },
    async downloadMailContentKeyList(context) {
      const { commit } = _moduleActionContext(context);
      commit.setIsMailContentTableLoading(true);
      const response = await getMailContentKeyList();
      commit.setMailContentTableData(response);
      if (response.length > 0) {
        commit.setSelectedMailContentKey(response[0].keyId);
      } else {
        commit.setSelectedMailContentKey(null);
      }
      commit.setIsMailContentTableLoading(false);
    },
    async downloadMailContent(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.selectedMailContentKey != null) {
        const requests = new MailContent();
        requests.mailConfigurationId = state.selectedMailBoxId == 0 ? null : state.selectedMailBoxId;
        requests.mailContentKeyEnum = state.selectedMailContentKey;
        const response = await getMailContent(requests);
        commit.setMailContent(response);
      }
    },
    async saveMailContent(context) {
      const { state, dispatch } = _moduleActionContext(context);
      if (state.selectedMailContentKey != null) {
        const requests = new MailContent();
        requests.mailConfigurationId = state.selectedMailBoxId == 0 ? null : state.selectedMailBoxId;
        requests.mailContentKeyEnum = state.selectedMailContentKey;
        requests.mailContents = state.mailContent.mailContent;
        await postSaveMailContent(requests);
        dispatch.downloadMailContent();
      }
    },
    async deleteMailContent(context) {
      const { state, dispatch } = _moduleActionContext(context);
      if (state.selectedMailContentKey != null) {
        const requests = new MailContent();
        requests.mailConfigurationId = state.selectedMailBoxId == 0 ? null : state.selectedMailBoxId;
        requests.mailContentKeyEnum = state.selectedMailContentKey;
        await postDeleteMailContent(requests);
        dispatch.downloadMailContent();
      }
    },
  },
});

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
export default AdministrationMailBoxContentModule;
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationMailBoxContentModule);
